module.exports = __webpack_public_path__ + "static/framingImg3-c95cf2aa5ed9694c719208801b257e73.jpg";